import { createFileRoute } from "@tanstack/react-router"
import { EventsAttendancePage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/events/attendance"
)({
  component: () => (
    <AuthorizationGate resource={Resource.EVENT} action={Action.READ}>
      <EventsAttendancePage />
    </AuthorizationGate>
  ),
})
